import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#F5F8FF]">
      {/* Header */}
      <header className="border-b border-[#E8EDF5] bg-[#F5F8FF]/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <Shield className="h-8 w-8 text-[#1B5AFF]" />
              <span className="text-xl font-bold text-[#0A0F1E]">VETT</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-[#0A0F1E] mb-8">Impressum</h1>

          <div className="prose prose-invert max-w-none space-y-8 text-[#0A0F1E]">
            <section className="bg-[#FFFFFF] border border-[#E8EDF5] rounded-xl p-8">
              <h2 className="text-2xl font-semibold text-[#0A0F1E] mb-4">Service Provider</h2>
              <p className="text-lg">
                <strong className="text-white">VETT</strong>
              </p>
              <p>Verified Work Record Platform</p>
              
              <div className="mt-6">
                <p><strong className="text-white">Website:</strong> <a href="https://vettpro.org" className="text-[#1B5AFF] hover:underline">vettpro.org</a></p>
                <p><strong className="text-white">Contact:</strong> <a href="mailto:contact@getvett.org" className="text-[#1B5AFF] hover:underline">contact@getvett.org</a></p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#0A0F1E] mb-4">Jurisdiction</h2>
              <p>
                VETT is a US-operated platform. This Impressum page is provided for transparency and international compliance purposes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#0A0F1E] mb-4">Disclaimer</h2>
              <p>
                The content on this website is provided for general information purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind about the completeness, accuracy, reliability, suitability, or availability of the website or the information contained on it.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#0A0F1E] mb-4">Legal Documents</h2>
              <ul className="space-y-2">
                <li><Link to="/privacy" className="text-[#1B5AFF] hover:underline">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-[#1B5AFF] hover:underline">Terms of Service</Link></li>
                <li><Link to="/cookies" className="text-[#1B5AFF] hover:underline">Cookie Policy</Link></li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#E8EDF5] py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <Shield className="h-5 w-5 text-[#1B5AFF]" />
              <span className="text-[#5B6472]">© 2026 VETT. All rights reserved.</span>
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-[#5B6472] hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="text-[#5B6472] hover:text-white">Terms of Service</Link>
              <Link to="/cookies" className="text-[#5B6472] hover:text-white">Cookie Policy</Link>
              <Link to="/impressum" className="text-white">Impressum</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;
